import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

const MAX_RECENTLY_USED = 5;

/**
 * Per-agent recently-used template tracking, persisted via the existing
 * `ui_settings` JSONB blob - same storage/pattern as
 * `useCannedResponseUsage` (composables/useCannedResponseGroups.js), kept
 * as a separate small composable rather than generalizing the two into one
 * shared abstraction: templates are keyed by numeric id/content_sid (not a
 * short_code string) and the two pickers (WhatsApp/Twilio) need
 * independent recency lists, so `storageKey` is a required param rather
 * than a hardcoded ui_settings field name.
 * @param {string} storageKey - the ui_settings key to persist under, e.g.
 *   'recently_used_whatsapp_templates'.
 */
export function useTemplateUsage(storageKey) {
  const { uiSettings, updateUISettings } = useUISettings();

  const recentlyUsedIds = computed(() => uiSettings.value[storageKey] || []);

  const recordUsage = id => {
    const withoutCurrent = recentlyUsedIds.value.filter(
      usedId => usedId !== id
    );
    updateUISettings({
      [storageKey]: [id, ...withoutCurrent].slice(0, MAX_RECENTLY_USED),
    });
  };

  return { recentlyUsedIds, recordUsage };
}
